import React from 'react';

function BasicPageBody({ children }) {
  return (
    <div id="SingleListingPageBody" className="space-y-0">
      {children}
    </div>
  );
}

export default BasicPageBody;
